import { Injectable }   from '@angular/core';
import { Storage }      from '@ionic/storage';

@Injectable()
export class LocalStorageService {  
    
    maxElementosBusqueda = 10;

    constructor(public storage:Storage) { 
        this.storage.create();
    }
      
    getToken() { return this.storage.get('token'); }
    setToken(token: string) { return this.storage.set('token', token);}
    clearToken()            { return this.storage.remove('token');}
    
    getUserData()               { return this.storage.get('usuario'); }
    setUserData(usuario:any)    { return this.storage.set('usuario', usuario); }
    clearUserData()             { return this.storage.remove('usuario'); }

    getUserPassword()               { return this.storage.get('usuarioPassword'); }
    setUserPassword(password:any)   { return this.storage.set('usuarioPassword', password); }

    getLastUserCheck()      { return this.storage.get('lastUserCheck'); }
    setLastUserCheck(fecha) { return this.storage.set('lastUserCheck', fecha); }

    getEspecieSeleccionada() { return this.storage.get('especieSeleccionada'); }
    setEspecieSeleccionada(especie:any) { return this.storage.set('especieSeleccionada', especie); }
    setEspecieSeleccionadaDatosClinicos(especie:any) { 
        this.getDatosClinicos().then(
            (response) => { 
                let datosClinicos = response;
                datosClinicos.EspecieID = especie.id;
                datosClinicos.EspecieNombre = especie.nombre;
                this.setDatosClinicos(datosClinicos);
            }
        );
    }
    clearEspecieSeleccionada()  { return this.storage.remove('especieSeleccionada'); }

    getUltimasBusquedas() { 
        return this.storage.get('ultimasBusquedas'); 
    }

    setUltimasBusquedas(arrayUltimasBusquedas) { 
        arrayUltimasBusquedas = arrayUltimasBusquedas.slice(0,this.maxElementosBusqueda);
        return this.storage.set('ultimasBusquedas', arrayUltimasBusquedas); 
    }

    clearUltimasBusquedas() { 
        return this.storage.remove('ultimasBusquedas'); 
    }

    getDebugFlag() { return this.storage.get("DebugFlag"); }
    setDebugFlag(flag:boolean) { return this.storage.set("DebugFlag", flag); }

    clearDatosClinicos()                    { return this.storage.remove("datosClinicos");  }
    getDatosClinicos()                      { return this.storage.get("datosClinicos");     }
    setDatosClinicos(datosClinicos:any)     { return this.storage.set("datosClinicos",   datosClinicos);     }
    
    clearDatosAnaliticos()                      { return this.storage.remove("datosAnaliticos");  }
    getDatosAnaliticos()                        { return this.storage.get("datosAnaliticos");     }
    setDatosAnaliticos(datosAnaliticos:any)     { return this.storage.set("datosAnaliticos",   datosAnaliticos);     }

    getLastIndicacion()                             { return this.storage.get("LastIndicacion"); }
    setLastIndicacion(idIndicacion:number)          { return this.storage.set("LastIndicacion", idIndicacion); }

    setEspeciesHabilitadas(especies)                { return this.storage.set("EspeciesHabilitadas", especies); }
    getEspeciesHabilitadas()                        { return this.storage.get("EspeciesHabilitadas"); }

    setGradoDeshidratacion(grado)   { return this.storage.set("GradoDeshidratacion", grado); }
    getGradoDeshidratacion()        { return this.storage.get("GradoDeshidratacion"); }
    clearGradoDeshidratacion()      { return this.storage.remove("GradoDeshidratacion"); }

    setPreguntasFluidos(preguntasFluidos)   { return this.storage.set("PreguntasFluidos", preguntasFluidos); }
    getPreguntasFluidos()                   { return this.storage.get("PreguntasFluidos"); }
    clearPreguntasFluidos()                 { return this.storage.remove("PreguntasFluidos"); }

    setEleccionDeshidratacion(eleccionDeshidratacion)   { return this.storage.set("EleccionDeshidratacion", eleccionDeshidratacion); }
    getEleccionDeshidratacion()                         { return this.storage.get("EleccionDeshidratacion"); }
    clearEleccionDeshidratacion()                       { return this.storage.remove("EleccionDeshidratacion"); }

    clearKeys() { return this.storage.clear().then(() => {});}

    getDispositivo() { return this.storage.get("Dispositivo"); }
    setDispositivo(dispositivo) { return this.storage.set("Dispositivo", dispositivo); }

    getDatosAlimento() { return this.storage.get("DatosAlimento"); }
    setDatosAlimento(datosAlimento) { return this.storage.set("DatosAlimento", datosAlimento); }
    clearDatosAlimento() { return this.storage.remove("DatosAlimento"); }

    getAyudaDeslizar() { return this.storage.get("AyudaDeslizar"); }
    setAyudaDeslizar(valor) { return this.storage.set("AyudaDeslizar", valor); }

}